/**
 * @module axis
 * This file exports constants used to reference scale type
 * consistently throughout the project.
 */
export const LINEAR = 'linear';
export const BAND = 'band';
export const TIME = 'temporal';
export const COLOR = 'color';
export const ORDINAL = 'ordinal';
export const QUANTIZE = 'quantize';
export const QUANTILE = 'quantile';
export const LOG = 'log';
export const POW = 'pow';
export const IDENTITY = 'identity';
export const SEQUENTIAL = 'sequential';
export const THRESHOLD = 'threshold';
